module.exports = __webpack_public_path__ + "img/hr.27ead35e.svg";